// Design tokens — single source of truth for navigation visual constants.
// Extracted from the original VerticalNavigationBar.tsx. Any visual fix goes here.

export const COLLAPSED_WIDTH = 280; // 64px if we're going to collapse the nav, but for now we are keeping it expanded by default
export const EXPANDED_WIDTH = 280;

export const NAV_TRANSITION = '350ms cubic-bezier(0.4, 0, 0.2, 1)';

export const NAV_TEXT_COLOR = '#3D3C38';
export const NAV_HOVER_BG_MAIN = '#D9F6FA';
export const NAV_HOVER_BG_SUB = '#F3F3F3';
export const NAV_FOCUS_COLOR = '#0C55B8';
export const NAV_BG = '#FFFFFF';
export const ITEM_BORDER = '#E5E5E6';

export const FONT_FAMILY = 'EnterpriseSansVF, Arial, sans-serif';
export const FONT_WEIGHT = 400;

export const ICON_SIZE = 24;
